import { jsonToHtml } from '@contentstack/json-rte-serializer';

export const mergeArticles = (priorityArticles, latest) => {
  const sliderArticles = priorityArticles ? [...priorityArticles] : [];
  const latestWithoutDuplicates = latest.filter(
    (article) => !sliderArticles.some((item) => item.id === article.id)
  );
  sliderArticles.push(...latestWithoutDuplicates);
  return sliderArticles;
};

export const ensureMinimumArticles = (sliderArticles, latest, minCount) => {
  if (sliderArticles.length < minCount) {
    const additionalArticlesNeeded = minCount - sliderArticles.length;
    sliderArticles.push(...latest.slice(0, additionalArticlesNeeded));
  }
};

export const generateDescription = (article) => {
  let descriptionText = '';

  if (article.json_rte) {
    try {
      descriptionText = jsonToHtml(article.json_rte);
    } catch (error) {
      console.error('Error parsing JSON RTE:', error);
      descriptionText = '';
    }
  }

  const structuredContent = parseAndTruncateRichText(descriptionText);
  return structuredContentToReadableText(structuredContent, 220);
};

function structuredContentToReadableText(contentArray, maxChars = 220) {
  let accumulatedText = '';

  for (const item of contentArray) {
    if (item.type === 'heading' || item.type === 'paragraph') {
      const text = Array.isArray(item.content)
        ? item.content.join(' ')
        : item.content;
      accumulatedText += text + ' ';

      if (accumulatedText.length >= maxChars) {
        accumulatedText = accumulatedText.slice(0, maxChars) + '...';
        break;
      }
    }
  }

  return accumulatedText.trim();
}

function parseAndTruncateRichText(richText) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(richText, 'text/html');
  const result = [];
  let paragraphGroup = [];

  Array.from(doc.body.childNodes).forEach((node) => {
    if (node.nodeName === 'P') {
      const paragraphText = node.textContent.trim();
      if (paragraphText) paragraphGroup.push(paragraphText);
    } else {
      if (paragraphGroup.length > 0) {
        result.push({
          type: 'paragraph',
          content: paragraphGroup
        });
        paragraphGroup = [];
      }

      if (node.nodeName === 'H2' || node.nodeName === 'H3') {
        result.push({
          type: 'heading',
          level: node.nodeName.toLowerCase(),
          content: node.textContent.trim()
        });
      }
    }
  });

  if (paragraphGroup.length > 0) {
    result.push({
      type: 'paragraph',
      content: paragraphGroup
    });
  }

  return result;
}
